import {
  getDefaultEventSettings,
  getEventMetadata,
  getSettings,
  saveDefaultEventSettings,
  saveSettings
} from '@/services/companySettingsService'
import { ElMessage } from 'element-plus'

const grwDefaultEventList = ['New Sessions', 'Page Visited', 'App Launched', 'UTM Visited', 'App Installed', 'App Uninstalled']

export default {
  name: 'CustomDomainComponent',
  data() {
    return {
      loading: true,
      savingData: false,
      savingRevenueSettings: false,

      settings: {
        putBitmapAtBottom: {
          value: false,
          key: 'campaign-tracking-open-pixel-at-bottom'
        }
      },

      revenueEventInfo: {
        event: '',
        property: ''
      },
      revenueEventList: [],
      revenueEventMetadata: {},
      revenuePropertyList: []
    }
  },

  computed: {
    isRevenueTrackingConfigured() {
      return !!(this.revenueEventInfo.event && this.revenueEventInfo.property)
    }
  },

  methods: {
    async fetchData() {
      this.loading = true
      try {
        const [settingsRes, eventMetadataRes, revenueSettingsRes] = await Promise.all([
          getSettings([this.settings.putBitmapAtBottom.key]),
          getEventMetadata(),
          getDefaultEventSettings('revenue')
        ])

        for (let i = 0; i < settingsRes.data.length; i++) {
          const key = settingsRes.data[i].key
          const value = settingsRes.data[i].value

          if (key === this.settings.putBitmapAtBottom.key) {
            // Coerce incoming value (string/number/boolean) to a strict boolean
            this.settings.putBitmapAtBottom.value = value === true || value === 'true' || value === 1 || value === '1'
          }
        }

        this.setRevenueEventMetadata(eventMetadataRes.data.data.eventList)
        if (revenueSettingsRes && revenueSettingsRes.data) {
          this.revenueEventInfo = {
            event: revenueSettingsRes.data.event || '',
            property: revenueSettingsRes.data.property || ''
          }
          if (this.revenueEventInfo.event) this.onRevenueEventSelect(true)
        }

        this.loading = false
      } catch (e) {
        this.reportError(e)
        ElMessage({
          type: 'error',
          message: 'Failed to fetch data. Please contact support.'
        })
        this.loading = false
      }
    },

    setRevenueEventMetadata(eventMetadata) {
      this.revenueEventMetadata = eventMetadata || {}
      this.revenueEventList = Object.keys(this.revenueEventMetadata)
        .filter(event => grwDefaultEventList.indexOf(event) < 0)
        .sort()
    },

    onRevenueEventSelect(dontClearProperty) {
      this.revenuePropertyList = this.revenueEventMetadata[this.revenueEventInfo.event] || []
      if (!dontClearProperty) {
        this.revenueEventInfo.property = ''
      }
    },

    async saveRevenueTrackingSettings() {
      if (this.isRevenueTrackingConfigured) {
        ElMessage({
          type: 'warning',
          message: 'Revenue tracking is already configured and cannot be changed.'
        })
        return
      }

      if (!this.revenueEventInfo.event) {
        ElMessage({
          type: 'warning',
          message: 'Please select revenue event.'
        })
        return
      }

      if (!this.revenueEventInfo.property) {
        ElMessage({
          type: 'warning',
          message: 'Please select revenue attribute.'
        })
        return
      }

      try {
        this.savingRevenueSettings = true
        await saveDefaultEventSettings({
          event_type: 'revenue',
          event: this.revenueEventInfo.event,
          property: this.revenueEventInfo.property
        })

        ElMessage({
          type: 'success',
          message: 'Revenue tracking settings saved successfully.'
        })
      } catch (e) {
        this.reportError(e)
        ElMessage({
          type: 'error',
          message: 'Failed to save revenue tracking settings. Please contact support.'
        })
      } finally {
        this.savingRevenueSettings = false
      }
    },

    async savePixelTracingPositionSetting() {
      try {
        this.loading = true

        // Save Pixel Tracing Position Setting.
        await saveSettings(
          {
            value: this.settings.putBitmapAtBottom.value
          },
          this.settings.putBitmapAtBottom.key
        )

        ElMessage({
          type: 'success',
          message: 'Pixel Tracing Position Setting saved successfully.'
        })

        this.loading = false
      } catch (e) {
        this.reportError(e)
        ElMessage({
          type: 'error',
          message: 'Failed to save pixel tracing position setting. Please contact support.'
        })
      }
    }
  },

  created() {
    this.fetchData()
  }
}
